export enum PolicyTypes {
  ACCIDENTAL_DEATH = 'ACCIDENTAL_DEATH',
  LOSS_INCOME = 'LOSS_INCOME',
  ACCIDENTAL_DISABILITY = 'ACCIDENTAL_DISABILITY',
  PIE = 'PIE',
  MA = 'MA',
  MQC = 'MQC',
  IPA = 'IPA',
}

export const PolicyTypeNames = {
  [PolicyTypes.ACCIDENTAL_DISABILITY]: 'Invalidez Permanente Total ou Parcial por Acidente',
  [PolicyTypes.ACCIDENTAL_DEATH]: 'Morte acidental',
  [PolicyTypes.LOSS_INCOME]: 'Perda de renda',
  [PolicyTypes.PIE]: 'Perda de renda',
  [PolicyTypes.MA]: 'Morte acidental',
  [PolicyTypes.MQC]: 'Morte acidental',
  [PolicyTypes.IPA]: 'Invalidez Permanente Total ou Parcial por Acidente',
};

export enum InsuranceStatus {
  // Seguro Renda
  FINISHED = 'FINISHED',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
  INITIAL = 'INITIAL',
  IN_PROGRESS = 'IN_PROGRESS',
  SIGNED = 'SIGNED',
  DRAFT = 'DRAFT',
  CANCELLED_BY_SYSTEM = 'CANCELLED_BY_SYSTEM',
  CANCELLED_BY_USER = 'CANCELLED_BY_USER',
  CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',

  // Seguro vida
  BILLING_CONFIRMED = 'BILLING_CONFIRMED',
  PENDING_PROPOSAL_PRE_IMPLEMENTATION = 'PENDING_PROPOSAL_PRE_IMPLEMENTATION',
  PROPOSAL_PRE_IMPLEMENTED = 'PROPOSAL_PRE_IMPLEMENTED',
  PENDING_PROPOSAL_PDF_GENERATION = 'PENDING_PROPOSAL_PDF_GENERATION',
  PENDING_PROPOSAL_NUMBER_GENERATION = 'PENDING_PROPOSAL_NUMBER_GENERATION',
  PROPOSAL_PDF_GENERATED = 'PROPOSAL_PDF_GENERATED',
  PENDING_SIGNATURE_COMMUNICATION = 'PENDING_SIGNATURE_COMMUNICATION',
  SIGNATURE_COMMUNICATED = 'SIGNATURE_COMMUNICATED',
  PENDING_PROPOSAL_PDF_INDEXING = 'PENDING_PROPOSAL_PDF_INDEXING',
  PROPOSAL_PDF_INDEXED = 'PROPOSAL_PDF_INDEXED',
  PENDING_PROPOSAL_STATUS = 'PENDING_PROPOSAL_STATUS',
  PROPOSAL_STATUS_RETRIEVED = 'PROPOSAL_STATUS_RETRIEVED',
  WAITING_ICATU_ACCEPTANCE = 'WAITING_ICATU_ACCEPTANCE',
  ICATU_ACCEPTED = 'ICATU_ACCEPTED',
  CANCEL_DUE_TO_DELINQUENCY = 'CANCEL_DUE_TO_DELINQUENCY',
  CANCEL_MADE = 'CANCEL_MADE',
  ICATU_CANCELED = 'ICATU_CANCELED',
  PROPOSAL_CANCELED = 'PROPOSAL_CANCELED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PROPOSAL_REJECTED = 'PROPOSAL_REJECTED',
  PROPOSAL_RISK_DENIED = 'PROPOSAL_RISK_DENIED',
  PENDING_PROPOSAL_CANCEL = 'PENDING_PROPOSAL_CANCEL',
}

export const InsuranceStatusNames = {
  [InsuranceStatus.FINISHED]: 'Finalizado',
  [InsuranceStatus.PAID]: 'Finalizado',
  [InsuranceStatus.CANCELLED]: 'Cancelado',
  [InsuranceStatus.INITIAL]: 'Em andamento',
  [InsuranceStatus.IN_PROGRESS]: 'Em andamento',
  [InsuranceStatus.SIGNED]: 'Em andamento',
  [InsuranceStatus.DRAFT]: 'Iniciado',
  [InsuranceStatus.CANCELLED_BY_SYSTEM]: 'Cancelado Automaticamente',
  [InsuranceStatus.CANCELLED_BY_USER]: 'Cancelado Pelo Usuario',
  [InsuranceStatus.CANCELLATION_REQUESTED]: 'Cancelamento Solicitado',

  [InsuranceStatus.BILLING_CONFIRMED]: 'Processando Ativação',
  [InsuranceStatus.PENDING_PROPOSAL_PRE_IMPLEMENTATION]: 'Processando Pagamento',
  [InsuranceStatus.PROPOSAL_PRE_IMPLEMENTED]: 'Processando Ativação',
  [InsuranceStatus.PENDING_PROPOSAL_PDF_GENERATION]: 'Processando Ativação',
  [InsuranceStatus.PENDING_PROPOSAL_NUMBER_GENERATION]: 'Processando Pagamento',
  [InsuranceStatus.PROPOSAL_PDF_GENERATED]: 'Processando Ativação',
  [InsuranceStatus.PENDING_SIGNATURE_COMMUNICATION]: 'Processando Ativação',
  [InsuranceStatus.SIGNATURE_COMMUNICATED]: 'Processando Ativação',
  [InsuranceStatus.PENDING_PROPOSAL_PDF_INDEXING]: 'Processando Ativação',
  [InsuranceStatus.PROPOSAL_PDF_INDEXED]: 'Processando Ativação',
  [InsuranceStatus.PENDING_PROPOSAL_STATUS]: 'Processando Ativação',
  [InsuranceStatus.PROPOSAL_STATUS_RETRIEVED]: 'Processando Ativação',
  [InsuranceStatus.WAITING_ICATU_ACCEPTANCE]: 'Processando Ativação',
  [InsuranceStatus.ICATU_ACCEPTED]: 'Ativo',
  [InsuranceStatus.CANCEL_DUE_TO_DELINQUENCY]: 'Processando Cancelamento',
  [InsuranceStatus.CANCEL_MADE]: 'Cancelado',
  [InsuranceStatus.ICATU_CANCELED]: 'Cancelado',
  [InsuranceStatus.PROPOSAL_CANCELED]: 'Cancelado',
  [InsuranceStatus.PAYMENT_FAILED]: 'Não Autorizado',
  [InsuranceStatus.PROPOSAL_REJECTED]: 'Não Autorizado',
  [InsuranceStatus.PROPOSAL_RISK_DENIED]: 'Não Autorizado',
  [InsuranceStatus.PENDING_PROPOSAL_CANCEL]: 'Processando Cancelamento',
};

export enum InsuranceStatusNameColor {
  'Ativo' = 'positive',
  'Finalizado' = 'positive',
  'Iniciado' = 'info',
  'Em andamento' = 'info',
  'Processando Ativação' = 'alert',
  'Cancelado' = 'negative',
  'Processando Cancelamento' = 'alert',
  'Processando Pagamento' = 'alert',
  'Não Autorizado' = 'negative',
  'Recusado' = 'negative',
}
